import React from 'react';
import { Box, Typography, Button, Paper, CircularProgress } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

interface SummaryStepProps {
  budget: number;
  strategyType: string;
  market: string;
  amountPerTrade: number;
  onBack: () => void;
  onComplete: () => void;
  loading: boolean;
}

const STRATEGY_LABELS: Record<string, string> = {
  marktmeister: 'MarktMeister',
};

const SummaryStep: React.FC<SummaryStepProps> = ({
  budget, strategyType, market, amountPerTrade, onBack, onComplete, loading,
}) => {
  return (
    <Box sx={{ maxWidth: 500, mx: 'auto', py: 4, textAlign: 'center' }}>
      <CheckCircle color="success" sx={{ fontSize: 64, mb: 2 }} />
      <Typography variant="h5" gutterBottom fontWeight={700}>
        Alles bereit!
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Hier ist deine Zusammenfassung:
      </Typography>

      <Paper sx={{ p: 3, borderRadius: 3, textAlign: 'left' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography color="text.secondary">Virtuelles Budget</Typography>
            <Typography fontWeight={600}>€{budget.toLocaleString('de-DE')}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography color="text.secondary">Strategie</Typography>
            <Typography fontWeight={600}>{STRATEGY_LABELS[strategyType] || strategyType}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography color="text.secondary">Markt</Typography>
            <Typography fontWeight={600}>{market}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography color="text.secondary">Betrag pro Trade</Typography>
            <Typography fontWeight={600}>€{amountPerTrade}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography color="text.secondary">Strategie-Budget (20%)</Typography>
            <Typography fontWeight={600}>€{(budget * 0.2).toLocaleString('de-DE')}</Typography>
          </Box>
        </Box>
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button onClick={onBack} disabled={loading}>Zurück</Button>
        <Button
          variant="contained"
          size="large"
          onClick={onComplete}
          disabled={loading}
          sx={{ px: 4 }}
        >
          {loading ? <CircularProgress size={24} /> : 'Paper Trading starten'}
        </Button>
      </Box>
    </Box>
  );
};

export default SummaryStep;
